import { React } from 'react'
import { View, Image, Text } from "react-native"

export default function Dispute (props)
{
        
        
        return (
             <View style={{marginTop:20 , borderRadius:10, width:"100%", height:"70%", backgroundColor:"#f6f8f9",alignItems:"center",justifyContent:"center", marginLeft:20}}>
                <Image source={require("../assets/images/coming_soon.gif")} style={{width:100, height:100, alignItems:"center"}}  />
                <Text style={{fontSize:25, fontFamily:"Inter",marginTop:20}}>Coming Soon</Text>

             </View>   
        )
}